import { useState } from "react";
import DynamicComponentsTable from "../../widgets/DynamicComponentsTable";

const supportedComponents = [
    { type: "DatePickerComponent", label: "Date" },
    { type: "DisplayTextComponent", label: "Text" },
    { type: "FacilitiesComponent", label: "Facility" },
    { type: "ICD10Component", label: "ICD10" },
    { type: "MultiSelectionComponent", label: "Multi" },
    { type: "PMBComponent", label: "PMB" },
    { type: "SingleSelectionComponent", label: "Single" },
];

export default function FieldOptionsDynamicTableContainer({ component, onPropertyChange }) {
    const _properties = component.properties ? Array.isArray(component.properties) ? component.properties : [] : [];

    const [columns, setColumns] = useState((_properties && _properties.find(a => a.property === "Options") && JSON.parse(_properties.find(a => a.property === "Options")?.values)) || [])
    // const [columns, setColumns] = useState([])

    // Handler for admin to add a column
    const handleAddColumn = () => {
        const updated = [
            ...columns,
            { key: "", label: "", type: supportedComponents[0].type }
        ];
        setColumns(updated);
        if (onPropertyChange) {
            onPropertyChange(JSON.stringify(updated));
        }
    };

    // Handler for admin to edit a column
    const handleColumnChange = (idx, field, value) => {
        const updated = columns.map((col, i) =>
            i === idx ? { ...col, [field]: value } : col
        );
        setColumns(updated);

        // Save to parent/component properties
        if (onPropertyChange) {
            onPropertyChange(JSON.stringify(updated));
        }
    };

    // Handler for admin to delete a column
    const handleDeleteColumn = (idx) => {
        const updated = columns.filter((_, i) => i !== idx);
        setColumns(updated);
        if (onPropertyChange) {
            onPropertyChange(JSON.stringify(updated));
        }
    };

    return (
        <div>
            <h5>Configure Table Columns</h5>
            <table className="table table-sm">
                <thead>
                    <tr>
                        <th>Key</th>
                        <th>Label</th>
                        <th>Type</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {columns.map((col, idx) => (
                        <tr key={idx}>
                            <td>
                                <input
                                    className="form-control form-control-sm"
                                    value={col.key}
                                    onChange={e => handleColumnChange(idx, "key", e.target.value)}
                                />
                            </td>
                            <td>
                                <input
                                    className="form-control form-control-sm"
                                    value={col.label}
                                    onChange={e => handleColumnChange(idx, "label", e.target.value)}
                                />
                            </td>
                            <td>
                                <select
                                    className="form-select form-select-sm"
                                    value={col.type}
                                    onChange={e => handleColumnChange(idx, "type", e.target.value)}
                                >
                                    {supportedComponents.map(sc => (
                                        <option key={sc.type} value={sc.type}>{sc.label}</option>
                                    ))}
                                </select>
                            </td>
                            <td>
                                <button className="btn btn-danger btn-sm" onClick={() => handleDeleteColumn(idx)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button className="btn btn-primary btn-sm mb-3" onClick={handleAddColumn}>Add Column</button>
            <hr />
            <DynamicComponentsTable component={{ properties: [{ property: "columns", values: JSON.stringify(columns) }] }} />
        </div>
    );
}
